import React, { useState } from "react";
import axios from "axios";
import "./InnerLeadershipRegPage.css";

import bannerBg from "../Assets/images/tobeused.jpg";
import sideImage from "../Assets/images/design.jpeg";

const API_URL = process.env.REACT_APP_BACKEND_API_URL;

// ================= DEADLINE =================
const deadline = new Date("2026-05-22T23:59:59");

const InnerLeadershipRegPage = () => {
  const [formData, setFormData] = useState({
    fullName: "",
    phone: "",
    email: "",
    organization: "",
    createdBy: "Via Link",
  });

  const [submitting, setSubmitting] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);
  const [error, setError] = useState("");
  const [isClosed, setIsClosed] = useState(new Date() > deadline);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // ✅ Deadline check
    if (new Date() > deadline) {
      setIsClosed(true);
      return;
    }

    if (!formData.fullName || !formData.organization) {
      setError("Please fill all required fields");
      return;
    }

    try {
      setSubmitting(true);
      setError("");

      await axios.post(
        `${API_URL}/inner-leadership`,
        formData
      );

      setShowSuccess(true);

      setFormData({
        fullName: "",
        phone: "",
        email: "",
        organization: "",
        createdBy: "Via Link",
      });

    } catch (err) {
      setError(
        err.response?.data?.message ||
        err.message ||
        "Submission failed"
      );
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="ilr-page">

      {/* ================= MODAL ================= */}
      {(showSuccess || error || isClosed) && (
        <div className="success-overlay">
          <div className="success-box">

            {showSuccess && (
              <>
                <h2>Registration Successful</h2>
                <p>You will receive an SMS shortly.</p>
              </>
            )}

            {error && (
              <>
                <h2 style={{ color: "#ff6b6b" }}>Error</h2>
                <p>{error}</p>
              </>
            )}

            {isClosed && (
              <>
                <h2 style={{ color: "#ff6b6b" }}>Registration Closed</h2>
                <p>The registration deadline has passed.</p>
              </>
            )}

            <button
              onClick={() => {
                setShowSuccess(false);
                setError("");
                setIsClosed(new Date() > deadline);
              }}
            >
              Close
            </button>

          </div>
        </div>
      )}

      {/* ================= BANNER ================= */}
      <div
        className="ilr-banner"
        style={{ backgroundImage: `url(${bannerBg})` }}
      >
        <div className="ilr-overlay">
          <h1>Welcome to Ample House</h1>
          <p>Inner Leadership Program</p>
        </div>
      </div>

      {/* ================= CONTENT ================= */}
      <div className="ilr-content">

        {/* LEFT IMAGE */}
        <div className="ilr-left">
          <img src={sideImage} alt="Inner Leadership" />
        </div>

        {/* RIGHT FORM */}
        <div className="ilr-right">

          <h2>RSVP</h2>

          <p className="rsvp-subtitle">
            Please fill in the form below to participate:
          </p>

          <form onSubmit={handleSubmit}>

            <div className="form-group">
              <label>
                Full Name <span className="req">*</span>
              </label>
              <input
                type="text"
                name="fullName"
                value={formData.fullName}
                onChange={handleChange}
                required
              />
            </div>

            <div className="form-group">
              <label>Phone</label>
              <input
                type="text"
                name="phone"
                value={formData.phone}
                onChange={handleChange}
              />
            </div>

            <div className="form-group">
              <label>Email</label>
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
              />
            </div>

            <div className="form-group">
              <label>
                Organization <span className="req">*</span>
              </label>
              <input
                type="text"
                name="organization"
                value={formData.organization}
                onChange={handleChange}
                required
              />
            </div>

            <button disabled={submitting || isClosed}>
              {isClosed
                ? "Registration Closed"
                : submitting
                ? "Submitting...please wait..."
                : "Register Now"}
            </button>

          </form>
        </div>

      </div>
    </div>
  );
};

export default InnerLeadershipRegPage;